<div class="bc-nav__container" [class.open]="open()" [style.padding-left.px]="indentation * 24">
  <span class="bc-nav__primary" (click)="toggle()">
    <mat-icon class="dropdown-arrow" [class.open]="open()">arrow_right</mat-icon>
    <atlas-icon
      [matIcon]="_container.icon"
      [logoUrl]="_container.logoUrl"
      [productName]="_container.label"
      *ngIf="_container.showIcon"
    ></atlas-icon>
    <span class="bc-nav__text">{{ text$ | async }}</span>
    <atlas-chip
      *ngIf="_container.chipContent"
      [text]="_container.chipContent | translate"
      [isNavChip]="true"
    ></atlas-chip>
  </span>
</div>
<div [@openClose]="open() ? 'open' : 'closed'">
  <ng-content></ng-content>
</div>
